import { EmpresaResponse } from "core/resources/types/empresa";
import axios from "infra/http";
import { useQuery } from "react-query";

function useFornecedorPessoa(id?: string) {
    return useQuery(
        `/v1/fornecedor/${id}/pessoa`,
        async () => {
            const res = await axios.get<EmpresaResponse>(`/v1/fornecedor/${id}/pessoa`);

            return res.data;
        },
        {
            enabled: !!id,
        }
    );
}

export default useFornecedorPessoa;
